import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameBBAI} from "../base/BaseGameBBAI";
import {Weather} from "./components/Weather";
import {AudioPlayer} from "../base/Audio";

// Constructor
export class AIControlLedApp extends BaseGameBBAI {

  constructor() {
    super(`data/ai-control-led.json`, 'ai-control');
    gsap.registerPlugin(Draggable, InertiaPlugin);

    this.currentForecastId = null;
    this.weather = null;

    this.weatherOverride = null;

    // Dedicated player for algorithm narrations — isolated from sound FX so
    // calls to app.audio.clearAll() don't kill it.
    this.narration = new AudioPlayer();
  }

  initGame() {
    super.initGame();

    this.weather = new Weather();

    this.weather.on("weatherUpdated", (weatherData) => {
      const newId = this.weather.currentForecast?.cms_id;
      if (!newId) return;

      this.currentForecastId = newId;
      $("#current-forecast").text(this.currentForecastId); // TODO: Remove after debugging
      this.updateVisually();
    });

    this.initEvents();

    // this.updateVisually();
  }

  /**
   * Smoothly change the weather video based on API data
   * @param forecastId
   */
  updateVisually() {
    const targetForecastId = this.weatherOverride ? this.weatherOverride : this.currentForecastId;
    console.log(this.weatherOverride, this.currentForecastId, targetForecastId)

    const $current = $(".weather-player.active");
    console.log($current, $current.data("forecast"), $current.data("forecast") === targetForecastId);

    // Skip if the target is already the active video
    if ($current.data("forecast") === targetForecastId) return;

    console.log("Updating weather to =>", targetForecastId);

    const $next = $(`.weather-player[data-forecast='${targetForecastId}']`);

    // TODO: Remove after debugging
    $("#current-forecast").text(targetForecastId);

    // Stop current video
    gsap.killTweensOf($(".weather-player"));
    if ($current.length) {
      $current.get(0).pause();
      $current.removeClass("active");
      gsap.set($current, {opacity: 0});
    }

    // Show and play new video
    $next.addClass("active");
    $next.get(0).currentTime = 0;
    $next.get(0).play();
    gsap.to($next, {opacity: 1.0, duration: 1.0, ease: "power1.out"});
  }

  initEvents() {
    // Debugging trigger rfid scans with key presses
    $(window).keypress((e) => {
      const keysMap = {
        "=": {
          id: null,
        },
        1: {
          id: "cloudy",
        },
        2: {
          id: "rainy",
        },
        3: {
          id: "snowing",
        },
        4: {
          id: "stormy",
        },
        5: {
          id: "sunny",
        },
        6: {
          id: "foggy",
        }
      }

      // Trigger forecast change
      if (Object.hasOwn(keysMap, e.key)) {
        this.weatherOverride = keysMap[e.key].id;
        this.updateVisually();
      }
    })
  }

  onScreenBridgeMessage(messageString) {
    super.onScreenBridgeMessage(messageString);
    console.log(messageString);

    if (messageString.startsWith("weatherOverride")) {
      const messageData = messageString.replace("weatherOverride ", "");
      const override = messageData.split("|")[0];
      this.weatherOverride = (!override || override === "none") ? null : override;

      console.log("Weather override =>", this.weatherOverride);

      this.updateVisually();
    } else if (messageString.startsWith("weather")) {
      const messageData = messageString.replace("weather ", "");
      const forecast = messageData.split("|")[0];
      console.log("Weather =>", forecast);

      this.currentForecastId = forecast;
      this.updateVisually();

    } else if (messageString.startsWith("narration")) {
      const messageData = messageString.replace("narration ", "").split(" ");
      if (messageData.length >= 2) {
        this.narration.play(`audio/narrations/ai-control/${messageData[0]}/${messageData[1]}.wav`, 1.0, true);
      } else if (messageData.length >= 1 && messageData[0] === "stop") {
        this.narration.clearAll();
      }

    }
  }

  initScreen(screenId) {
  }

  initScreenSaver() {
    // Empty function to bypass the screen saver function
    // This will prevent triggering the Are you still there popup and go back to start
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {
    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);

    // Clear any manual weather override and refresh to live forecast
    this.weatherOverride = null;
    this.updateVisually();

    const resetCallback = () => {
      // Things that reset after goToScreen
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
